<form [formGroup]="form">
  <div class="flex flex-col gap-3">
    <div class="grid grid-cols-2">
      <div class="flex flex-col gap-2">
        <label for="title">Topic Title</label>
        <input type="text" pInputText formControlName="title" />
      </div>
    </div>
    <div>
      <p-fieldset
        legend="Add Topic Details"
        [toggleable]="true"
        [collapsed]="true">
        <ng-template #expandicon>
          <i class="pi pi-angle-right"></i>
        </ng-template>
        <ng-template #collapseicon>
          <i class="pi pi-angle-down"></i>
        </ng-template>
        <p-fluid>
          <div class="grid grid-cols-3 gap-4">
            <div class="col-span-2 flex flex-col gap-3">
              <div class="flex flex-col gap-2">
                <label for="oneLiner">Short Description</label>
                <input
                  fluid
                  type="text"
                  pInputText
                  formControlName="oneLiner" />
                <small>
                  {{ form.get('oneLiner').value.length }} /
                  {{ config.inputLengths.SESSION_ONE_LINER }} characters
                </small>
              </div>
              <div class="flex flex-col gap-2">
                <label for="description">Detailed Description</label>
                <textarea
                  pTextarea
                  [fluid]="true"
                  id="description"
                  rows="8"
                  id="context"
                  formControlName="description"
                  autoResize="true"
                  style="resize: none"></textarea>
              </div>
            </div>
            <app-image-upload
              (uploadComplete)="handleUploadComplete($event)"
              (uploadStart)="handleUploadStart()"
              [defaultImage]="
                'image/default_session_thumbnail.png'
              "></app-image-upload>
          </div>
        </p-fluid>
      </p-fieldset>
    </div>
    <div class="flex justify-content-end">
      <p-button
        label="Create Topic"
        severity="primary"
        [disabled]="form.invalid"
        (click)="handleSubmit()" />
    </div>
  </div>
</form>
